// extracted by mini-css-extract-plugin
module.exports = {"container":"TimeRange_container__34eue","slider":"TimeRange_slider__1jhSh","timeWrapper":"TimeRange_timeWrapper__1J3QC","time":"TimeRange_time__2VBT0"};